import { Container, Col, Row } from "react-bootstrap";
import './Footer.scss';
import { NavLink } from "react-router-dom";
import { FaFacebookF } from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa';
import { BiPhoneCall } from 'react-icons/bi';
import { BiLocationPlus } from 'react-icons/bi';
import { FaArrowUp } from "react-icons/fa";
import configUrl from "../config";

function Footer() {

  window.onscroll = function() {scrollFunction()};

  const Scrollbutton = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      document.getElementById("topScroll").style.display = "block";
    } else {
      document.getElementById("topScroll").style.display = "none";
    }
  }
  return (
    <>
      <Container fluid className="section footer-section section_margin">
        <Container>
          <Container className="footer-widget-wrap">
            <Row>
              <Col md={4}>
                <div>
                  <a className="footer-logo" href="#">
                    <img src={`${configUrl.ImgBaseUrl}/images/logo.png`} alt="Footer" className="logo" />
                  </a>
                </div>

                <div className="widget-info">
                  <ul>

                    <li className="d-flex align-items-center">
                      <div className="info-icon">
                        <BiPhoneCall />
                      </div>
                      <div className="info-text">
                        <span>
                        +81-3-6459-4611
                        </span>
                      </div>
                    </li>

                    <li className="d-flex">
                      <div className="info-icon">
                        <BiLocationPlus />
                      </div>
                      <div className="info-text">
                        <span>
                        Head Office :
 824-66 Jiyuugaoka, Tsukbashi, Ibaraki 300-1266
 
Tokyo Lab:
 Shibaura, Minatoku, Tokyo 108-0023
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={4}>
                <div className="footer-widget">
                  <h4 className="footer-widget-title"> Useful Links</h4>
                  <div className="widget-link">
                    <ul className="link">
                      <li>
                        <NavLink className="navlnk" to="/">
                          Terms &amp; Conditions
                        </NavLink>
                      </li>

                      <li>
                        <NavLink className="navlnk" to="/aboutus">
                          About Company
                        </NavLink>
                      </li>

                      <li>
                        <NavLink className="navlnk" to="/">
                          Policy
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div className="footer-widget">
                  <h4 className="footer-widget-title"> Support</h4>
                  <div className="widget-link">
                    <ul className="link">
                      <li>
                        <NavLink className="navlnk" to="/contactus">
                          Contact Us
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className="navlnk" to="/">
                          FAQS
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>

            </Row>
          </Container>
        </Container>

        <Container fluid className="footer-copyright-area">
          <Container>
            <div className="footer-copyright-wrap">
              <Row>
                <Col md={6} xs={12} sm={12} className=" d-flex align-items-center foot_text">
                  <div className="copyright-text ">
                    <p>© Copyrights 2025 DTS Inc. All rights reserved. </p>
                  </div>
                </Col>

                <Col md={6} xs={12} sm={12} className="foot_icons">
                  <div className="copyright-social">
                    <ul className="social">

                      <li class="foot_icon">
                        <FaFacebookF />
                      </li>

                      <li class="foot_icon">
                        <FaLinkedinIn />
                      </li>

                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Container>
      </Container>
      <div className="scrollButton" onClick={Scrollbutton} id="topScroll">
        <FaArrowUp />
      </div>
    </>
  );
}

export default Footer;